import { useEffect } from 'react';
import PropTypes from 'prop-types';

function ExternalRedirect({ href }) {
  useEffect(() => window.location.replace(href));
  return <div>Redirecting...</div>;
}

export default ExternalRedirect;

ExternalRedirect.propTypes = {
  href: PropTypes.string,
};
